import styles from './Logo.module.css';

/**
 * The Corocanto logo (C:\tooppa\corocanto-docs\logo): four singers in the figure of the part
 * buttons (ModeIcon), S A T B from left to right. Every head is a note head with a stem, and one
 * beam joins the four: the unity of the choir. Shoulders in ink, the music in the accent colour.
 */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg className={styles.mark} viewBox="0 0 64 64" width={size} height={size} aria-hidden="true" focusable="false">
      <g transform="translate(0.9 1.05)">
        <g fill="none" stroke="var(--ink)" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round">
          <path d="M 6.38 44.5 c 0 -3.88 2.1 -6.09 4.62 -6.09 s 4.62 2.21 4.62 6.09" />
          <path d="M 19.38 48 c 0 -3.88 2.1 -6.09 4.62 -6.09 s 4.62 2.21 4.62 6.09" />
          <path d="M 32.38 51.5 c 0 -3.88 2.1 -6.09 4.62 -6.09 s 4.62 2.21 4.62 6.09" />
          <path d="M 45.38 55 c 0 -3.88 2.1 -6.09 4.62 -6.09 s 4.62 2.21 4.62 6.09" />
        </g>
        <g fill="var(--accent)">
          <ellipse cx={11} cy={33} rx={4.3} ry={3.2} transform="rotate(-22 11 33)" />
          <ellipse cx={24} cy={36.5} rx={4.3} ry={3.2} transform="rotate(-22 24 36.5)" />
          <ellipse cx={37} cy={40} rx={4.3} ry={3.2} transform="rotate(-22 37 40)" />
          <ellipse cx={50} cy={43.5} rx={4.3} ry={3.2} transform="rotate(-22 50 43.5)" />
        </g>
        <g stroke="var(--accent)" strokeWidth={2.2} strokeLinecap="round">
          <path d="M 14.6 32 V 8" />
          <path d="M 27.6 35.5 V 11.38" />
          <path d="M 40.6 39 V 14.76" />
          <path d="M 53.6 42.5 V 18.14" />
        </g>
        <path d="M 14.6 8 L 53.6 18.2" stroke="var(--accent)" strokeWidth={4.6} strokeLinecap="round" />
      </g>
    </svg>
  );
}

/** The mark and the name ("Coro" in ink, "canto" in the accent colour), as in the headers. */
export function Brand({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <span className={className ? `${styles.brand} ${className}` : styles.brand}>
      <LogoMark size={size} />
      <span className={styles.name}>
        Coro<span className={styles.accent}>canto</span>
      </span>
    </span>
  );
}
